//** Import Components */
import {
  Table,
  Tooltip,
  Empty,
  Space,
  Collapse,
  Grid,
  Button,
  Pagination,
} from "antd";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { TABLE_DATE_FORMAT } from "../common/constants";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faReceipt } from "@fortawesome/free-solid-svg-icons";
import { useState } from "react";
import OrderTaxesValue from "../common/OrderTaxesValue";

export const useManagementOrdersUser = () => {
  const dateFormat = TABLE_DATE_FORMAT;
  const navigate = useNavigate();
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const { Panel } = Collapse;

  const columns = [
    {
      title: "Order ID",
      key: "order_id",
      render: (text) => <>{text.id}</>,
    },
    {
      title: "Restaurant Name",
      key: "ad_name",
      render: (text) => <>{text.business_name}</>,
    },
    {
      title: "Date Created",
      key: "created",
      render: (text) => (
        <>{moment(new Date(text && text.date_order)).format(dateFormat)}</>
      ),
    },
    {
      title: "Delivery Type",
      key: "delivery_type",
      render: (text) => <>{text.delivery_type}</>,
    },
    {
      title: "Status",
      key: "staus",
      render: (text) => <>{text.order_status}</>,
    },
    {
      title: "Total Amount",
      key: "total_amount",
      render: (text) => <>$ {text.total_price_order}</>,
    },
    {
      title: "Action",
      key: "action",
      render: (text) => (
        <Space size="middle">
          <button
            onClick={() => {
              navigate(`${text.id}`);
            }}
          >
            <Tooltip title="Receipt">
              <FontAwesomeIcon icon={faReceipt} />
            </Tooltip>
          </button>
        </Space>
      ),
    },
  ];

  const CardListComponent = ({ listItems }) => {
    const [currentPage, setCurrentPage] = useState(1);
    const pageSize = 10;
    const start = (currentPage - 1) * pageSize;
    const currentItems = listItems.slice(start, start + pageSize);

    return (
      <>
        <Collapse accordion>
          {currentItems.map((item) => (
            <Panel
              key={item.id}
              header={
                <div>
                  <strong>{item.business_name}</strong> -{" "}
                  {moment(item.date_order).format(dateFormat)}
                </div>
              }
            >
              <p>
                <strong>Order ID:</strong> {item.id}
              </p>
              <p>
                <strong>Delivery Type:</strong> {item.delivery_type}
              </p>
              <p>
                <strong>Status:</strong> {item.order_status}
              </p>
              <div>
                <OrderTaxesValue order={item} />
              </div>
              <p>
                <strong>Total:</strong> ${item.total_price_order}
              </p>
              <Button type="primary" onClick={() => navigate(`${item.id}`)}>
                <Tooltip title="Receipt">
                  <FontAwesomeIcon icon={faReceipt} />
                </Tooltip>
              </Button>
            </Panel>
          ))}
        </Collapse>

        <div style={{ marginTop: 16, textAlign: "center" }}>
          <Pagination
            current={currentPage}
            pageSize={pageSize}
            total={listItems.length}
            onChange={(page) => setCurrentPage(page)}
            size="small"
          />
        </div>
      </>
    );
  };

  const ListComponent = ({ emptyMessage, listItems }) => {
    if (!Array.isArray(listItems) || listItems.length === 0) {
      return (
        <Empty
          image="https://gw.alipayobjects.com/zos/antfincdn/ZHrcdLPrvN/empty.svg"
          imageStyle={{ height: 60 }}
          description={<span>{emptyMessage}</span>}
        />
      );
    }

    return screens.md ? (
      <Table columns={columns} dataSource={listItems} />
    ) : (
      <CardListComponent listItems={listItems} />
    );
  };

  return [ListComponent];
};
